import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import { ContactHelper } from 'src/app/helpers/contact-helper';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import Contact from 'src/app/model/Contact/contact';
import { ProjectPlacement } from 'src/app/model/project/projectPlacement';
import { FormatPhoneNumber } from 'src/app/modules/app-pipes/format-phonenumber';
import { AuthService } from 'src/app/services/auth.service';
import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { IPBoardAppointmentHelper } from '../helper/ip-board-appointment-helper';
import { AppointmentContactChoicesControllerRequestService } from '../service/appointment-contact-choices-controller-request.service';

@Component({
  selector: 'adjustment-ip-board-appointment',
  templateUrl: '../ip-board-appointment.component.html',
  styleUrls: ['../ip-board-appointment.component.scss'],
  providers: [FormatPhoneNumber],
})
export class AdjustmentIPBoardAppointmentComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  projectContacts: ProjectContact[];

  @Input()
  projectPlacement: ProjectPlacement;

  @Input()
  client: boolean = false;

  @Input()
  disabled: boolean = false;

  @Output()
  save = new EventEmitter<any>();

  contactChoices: Contact[];

  hideNeedAppointment: boolean = false;
  nullIsFalse = true;
  flexRow = false;

  constructor(
    private appointmentContactChoicesControllerRequestService: AppointmentContactChoicesControllerRequestService,
    private authService: AuthService,
    private formatPhoneNumber: FormatPhoneNumber
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.projectPlacement.appointmentContact != null) {
      ContactHelper.setFormDisplays(
        this.projectPlacement.appointmentContact,
        this.formatPhoneNumber
      );
    }
    this.fetchContactChoices();
  }

  private fetchContactChoices(): void {
    const companyIds =
      IPBoardAppointmentHelper.getCompanyIdsFromProjectContacts(
        this.projectContacts
      );
    if (CollectionHelper.isPopulated(companyIds)) {
      this.appointmentContactChoicesControllerRequestService
        .getAppointmentContactChoices(companyIds)
        .then((choices) => {
          this.doSetContactChoices(choices);
          if (
            this.client &&
            this.projectPlacement.appointmentWithCustomer &&
            this.projectPlacement.appointmentContact == null
          ) {
            this.tryFillUserContact();
          }
        });
    } else {
      this.doSetContactChoices([]);
    }
  }

  private doSetContactChoices(choices: Contact[]): void {
    IPBoardAppointmentHelper.processContactChoices(
      choices,
      this.projectPlacement,
      this.formatPhoneNumber
    );
    this.contactChoices = choices;
  }

  private tryFillUserContact(): void {
    const matchingContact = ContactHelper.getMatchingContact(
      this.contactChoices,
      this.authService.getAuthenticatedUser()
    );
    if (matchingContact != null) {
      this.projectPlacement.appointmentContact = matchingContact;
    }
  }

  appointmentChange(value: boolean): void {
    this.projectPlacement.appointment = value;
    this.save.emit();
  }

  appointmentWithCustomerChange(value: boolean): void {
    this.projectPlacement.appointmentWithCustomer = value;
    if (this.projectPlacement.appointmentWithCustomer == null) {
      this.resetCustomerFields();
      this.resetOwnerFields();
    } else if (this.projectPlacement.appointmentWithCustomer === true) {
      this.resetOwnerFields();
      if (this.client && this.projectPlacement.appointmentContact == null) {
        this.tryFillUserContact();
      }
    } else {
      this.resetCustomerFields();
    }
    this.save.emit();
  }

  private resetCustomerFields(): void {
    this.projectPlacement.appointmentContact = null;
  }

  private resetOwnerFields(): void {
    this.projectPlacement.appointmentName = null;
    this.projectPlacement.appointmentPhoneNumber = null;
    this.projectPlacement.appointmentEmail = null;
  }

  appointmentContactChange(): void {
    this.save.emit();
  }

  needAppointmentInfoChange(value: string): void {
    this.projectPlacement.needAppointmentInfo = value;
    this.save.emit();
  }

  appointmentNameChange(): void {
    this.save.emit();
  }

  appointmentPhoneNumberChange(value: string): void {
    this.projectPlacement.appointmentPhoneNumber =
      value == null ? null : this.formatPhoneNumber.transform(value);
    this.save.emit();
  }

  appointmentEmailChange(): void {
    this.save.emit();
  }

  compareEntities(o1: Contact, o2: Contact): boolean {
    return GeneralHelper.compareEntities(o1, o2);
  }

  trackById(index: number, obj: Contact): number {
    return GeneralHelper.trackById(index, obj);
  }
}
